import { render, staticRenderFns } from "./LoginAndRegisterModalTwo.vue?vue&type=template&id=29589f55&scoped=true&"
import script from "./LoginAndRegisterModalTwo.vue?vue&type=script&lang=js&"
export * from "./LoginAndRegisterModalTwo.vue?vue&type=script&lang=js&"
import style0 from "./LoginAndRegisterModalTwo.vue?vue&type=style&index=0&id=29589f55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29589f55",
  null
  
)

export default component.exports